  
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule, ModuleWithProviders } from '@angular/core';

import { NbSharedModule } from './shared.module';
import { NbMenuComponent, NbMenuItemComponent } from './menu.component';
import { NbMenuService, NbIconModule, NbButtonModule } from '@nebular/theme';
import { NbMenuInternalService } from './menu.service';

const nbMenuComponents = [NbMenuComponent, NbMenuItemComponent];

const NB_MENU_PROVIDERS = [NbMenuService, NbMenuInternalService];

@NgModule({
  imports: [
    NbSharedModule,
    NbIconModule,
    NbButtonModule,
  ],
  declarations: [...nbMenuComponents],
  exports: [...nbMenuComponents],
})
export class MenuModule {
  static forRoot(): ModuleWithProviders<MenuModule> {
    return {
      ngModule: MenuModule,
      providers: [
        ...NB_MENU_PROVIDERS,
      ],
    };
  }
}
